import request from '@/modules/base/util/request'
import dashboardConfig from '@/modules/dashboard/config'

/*
 * Actions
 */
const START_FETCHING_STATS_DATA = 'orgamax/dashboard/transactionStats/START_FETCHING_STATS_DATA'
const FINISHED_FETCHING_STATS_DATA = 'orgamax/dashboard/transactionStats/FINISHED_FETCHING_STATS_DATA'
const ERROR_FETCHING_STATS_DATA = 'orgamax/dashboard/transactionStats/ERROR_FETCHING_STATS_DATA'

/*
 * Reducer
 */
const initialState = {
  isLoading: true,
  errorOccurred: false,
  statsData: {},
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case START_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case FINISHED_FETCHING_STATS_DATA:
      const { statsData } = action
      return Object.assign({}, state, {
        isLoading: false,
        errorOccurred: false,
        statsData,
      })

    case ERROR_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: false,
        errorOccurred: true,
      })

    default:
      return state
  }
}

/*
 * Action Creators
 */
const startFetchingStatsData = () => {
  return {
    type: START_FETCHING_STATS_DATA,
  }
}

const finishedFetchingStatsData = statsData => {
  return {
    type: FINISHED_FETCHING_STATS_DATA,
    statsData,
  }
}

const errorFetchingStatsData = () => {
  return {
    type: ERROR_FETCHING_STATS_DATA,
  }
}

export const fetchStatsData = () => {
  return dispatch => {
    dispatch(startFetchingStatsData())

    Promise.all([
      request(`${dashboardConfig.statistic}invoice`, { auth: true, isConcurrent: true }),
      request(`${dashboardConfig.statistic}offer`, { auth: true, isConcurrent: true }),
      request(`${dashboardConfig.statistic}order`, { auth: true, isConcurrent: true }),
    ])
      .then(([invoiceStatsResponse, offerStatsResponse, orderStatsResponse]) => {
        const { body: { data: { invoiceStats } } } = invoiceStatsResponse
        const { body: { data: { offerStats } } } = offerStatsResponse
        const { body: { data: { orderStats } } } = orderStatsResponse
        dispatch(
          finishedFetchingStatsData({
            invoiceStats,
            offerStats,
            orderStats,
          }),
        )
      })
      .catch(() => {
        dispatch(errorFetchingStatsData())
      })
  }
}
